import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import * as actions from 'actions/pathBuilder';
import ConfirmationModal from './ConfirmationModal';

class DiscardChangesButton extends PureComponent {
  constructor() {
    super();
    this.state = { showConfirmationModal: false };
    this.handleClick = this.handleClick.bind(this);
    this.handleCancel = this.handleCancel.bind(this);
  }

  handleClick() {
    if (this.props.hasUnsavedChanges.value) {
      this.setState({ showConfirmationModal: true });
    } else {
      this.props.discardChanges();
    }
  }

  handleCancel() {
    this.setState({ showConfirmationModal: false });
  }

  render() {
    const { discardChanges, hasUnsavedChanges } = this.props;
    return (
      <div className="d-ib mr-16">
        <button
          type="button"
          className="u-linkBtn u-linkBtn--dark td-u"
          onClick={this.handleClick}
          children={hasUnsavedChanges.value ? 'Discard Changes' : 'Cancel'}
        />
        {this.state.showConfirmationModal && (
          <ConfirmationModal
            onSubmit={discardChanges}
            onDismiss={this.handleCancel}
          />
        )}
      </div>
    );
  }
}

const mapDispatchToProps = {
  discardChanges: actions.restoreRevision,
};

export default connect(null, mapDispatchToProps)(DiscardChangesButton);
